// components/PrivateRoute.jsx
import { Navigate } from "react-router";
import { useAuth } from "../hooks/useAuth";

export default function MustOpenRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}
